import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";
import WOW from "wowjs";
import { FaAngleUp } from "react-icons/fa";

//Pages
import About from "./pages/About";
import Projects from "./pages/Projects";
import DonateNow from "./pages/DonateNow";
import Contact from "./pages/Contact";
import ScrollToTopRoute from "./components/scroll-to-top-route/ScrollToTopRoute";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import Home from "./pages/Home";
import WhatWeDo from "./pages/WhatWeDo";
import { Bounce, ToastContainer } from "react-toastify";

function App() {
  useEffect(() => {
    new WOW.WOW({
      live: false,
    }).init();
  }, []);
  return (
    <Router>
      <ScrollToTopRoute />
      <Routes>
        <Route path={`${process.env.PUBLIC_URL}/`} exact element={<Home />} />
        <Route
          path={`${process.env.PUBLIC_URL}/about`}
          exact
          element={<About />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/projects`}
          exact
          element={<Projects />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/donate-now`}
          exact
          element={<DonateNow />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/contact`}
          exact
          element={<Contact />}
        />

        <Route
          path={`${process.env.PUBLIC_URL}/what-we-do`}
          exact
          element={<WhatWeDo />}
        />

        <Route path={`${process.env.PUBLIC_URL}/*`} exact element={<Home />} />
      </Routes>
      <ScrollToTop
        className="scrollUp"
        smooth
        top="1500"
        component={<FaAngleUp />}
      />
      <ToastContainer
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick={true}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        transition={Bounce}
      />
    </Router>
  );
}

export default App;
